import { render } from "./SeasonAveragesV2.vue?vue&type=template&id=42805c2e&scoped=true"
import script from "./SeasonAveragesV2.vue?vue&type=script&lang=ts"
export * from "./SeasonAveragesV2.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-42805c2e"

export default script